import { Component, OnInit } from '@angular/core';
import { NgxRolesService } from 'ngx-permissions';


@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.css']
})
export class UserManualComponent implements OnInit {
  constructor(
    private roleService: NgxRolesService,
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/user-manual/user-manual.component.ts